import axios from 'axios'

const S3_CDN_URL = 'https://s3.ap-southeast-1.amazonaws.com/cdn-member.omnihotelier.com/public/data/feature-upsell-content.json'
const LOCAL_URL = '/upsell/json/feature-upsell-content.json'

export default {
  namespaced: true,
  state: {
    status: '',
    contents: {},
    loaded: false
  },
  mutations: {
    request(state) {
      state.status = 'loading'
    },
    read(state, { contents }) {
      state.contents = { ...contents }
      state.loaded = true
    },
    error(state) {
      state.status = 'error'
    },
    success(state) {
      state.status = 'success'
    }
  },
  actions: {
    fetchContents({ commit, state }) {
      commit('request')
      if (state.loaded && Object.keys(state.contents).length > 0) {
        return Promise.resolve(state.contents)
      }

      return axios.get(S3_CDN_URL, { headers: { 'Authorization': '' } })
        .then((result) => {
          const contents = result.data?.features || {}
          commit('read', { contents })
          commit('success')
          return contents
        })
        .catch(() => {
          // Fallback to local JSON during development/testing
          return axios.get(LOCAL_URL, { headers: { 'Authorization': '' } })
            .then((result) => {
              const contents = result.data?.features || {}
              commit('read', { contents })
              commit('success')
              return contents
            })
            .catch(() => {
              commit('error')
              commit('read', { contents: {} })
              return {}
            })
        })
    }
  },
  getters: {
    contents: (state) => state.contents,
    getContent: (state) => (featureKey) => state.contents?.[featureKey] || null
  }
}
